<template>
    <div class="social-banner social-banner__meta rounded-lg">


        <InstagramReelBanner class="social-banner__item"></InstagramReelBanner>

        <div class="w-100 h-100 d-flex flex-column justify-center px-4 py-2 ga-3">
            <div class="text-h5 font-weight-bold text-left">Reels</div>
            <div style="letter-spacing: 0.6px;">
                Post short video Reels on Facebook and Instagram, include
                your code, and gain referrals!
            </div>
        </div>


    </div>
</template>



<script setup>

import InstagramReelBanner from '@/icons/InstagramReelBanner.vue';

</script>